//  @flow
import React from 'react';
import classnames from 'classnames';

import './SkeletonTiles.scss';

type Props = {
  amount: number,
  square: boolean,
  minimal: boolean,
  fullWidth: boolean,
  children: Element,
};

const SkeletonTilesComponent = ({ amount, square, minimal, fullWidth, children }: Props) => {
  const classNames = classnames('skeleton-tiles-component__tile', {
    'u-1/1@small u-1/2@medium u-1/3@large': square,
    'skeleton-tiles-component--square': square,
    'skeleton-tiles-component--minimal': minimal,
    'skeleton-tiles-component--fullWidth': fullWidth,
  });

  const tiles = new Array(amount).fill('tile').map((_, i) => {
    const index = `skeleton-key-${i}`;
    return (
      <div className={classNames} key={index}>
        <div className="skeleton-tiles-component__image-placeholder" />
        <div className="skeleton-tiles-component__container" key={index}>
          <div className="skeleton-tiles-component__text-placeholder" />
          <div className="skeleton-tiles-component__text-placeholder" />
          {!minimal && <div className="skeleton-tiles-component__text-placeholder" />}
          <div className="skeleton-tiles-component__text-placeholder skeleton-tiles-component__text-placeholder--half-width" />
          {children}
        </div>
      </div>
    );
  });

  return <div className="skeleton-tiles-component">{tiles}</div>;
};

SkeletonTilesComponent.defaultProps = {
  amount: 6,
};

SkeletonTilesComponent.displayName = 'SkeletonTiles';

export default SkeletonTilesComponent;
